<template>
    <div v-if="CallForm.initialized">
        <div class="row d-flex justify-content-center">
            <div class="col-lg-12">
                <div class="align-right mb-3 dropdown" style="position: absolute; right: 0; z-index: 10">
                    <base-button
                        type="primary"
                        size="lg"
                        class="btn-fill"
                        data-toggle="dropdown">
                        {{ $t('proposals.button_title__download_all') }}
                    </base-button>
                    <ul class="dropdown-menu">
                        <li><a @click="doExport('concept-note')">{{ $t('proposals.tab__concept_note') }}</a></li>
                        <li><a @click="doExport('full-proposal')" v-if="CallForm.technical_status === 'Preselected'">{{ $t('proposals.tab__full_proposal') }}</a></li>
                    </ul>
                </div>
                <tabs ref="tab-proposal-type" type="info" @activate-tab="activateTab" :value="CallForm.technical_status === 'Preselected' ? $t('proposals.tab__full_proposal') : $t('proposals.tab__concept_note')" square>

                    <tab-pane :id="'concept-note'" :label="$t('proposals.tab__concept_note')">
                        <grant-wizard v-if="CallForm.initialized" :is-editable="CallForm.isEditable">
                            <grant-wizard-tab :before-change="() => validateStep('cn-project-presentation')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">1</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{ $t('proposals.cn_step_title__project_presentation') }}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <concept-note-step-project-presentation ref="cn-project-presentation"></concept-note-step-project-presentation>
                                </div>
                            </grant-wizard-tab>

                            <grant-wizard-tab :before-change="() => validateStep('cn-applicant')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">2</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{$t('proposals.cn_step_title__applicant')}}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <concept-note-step-applicant ref="cn-applicant"></concept-note-step-applicant>
                                </div>
                            </grant-wizard-tab>

                            <grant-wizard-tab :before-change="() => validateStep('cn-concept-note')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">3</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{$t('proposals.cn_step_title__concept_note')}}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <concept-note-step-concept-note ref="cn-concept-note"></concept-note-step-concept-note>
                                </div>
                            </grant-wizard-tab>

                            <grant-wizard-tab :before-change="() => validateStep('cn-supporting-documents')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">4</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{$t('proposals.cn_step_title__supporting_documents')}}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <concept-note-step-supporting-documents ref="cn-supporting-documents"></concept-note-step-supporting-documents>
                                </div>
                            </grant-wizard-tab>
                        </grant-wizard>
                    </tab-pane>
                    <tab-pane v-if="CallForm.technical_status === 'Preselected'" :id="'full-proposal'" :label="$t('proposals.tab__full_proposal')">


                        <ul class="nav nav-pills nav-pills-info nav-pills-icons" style="margin: -10px 0 20px 0" v-if="CallForm.has_revision">
                            <li class="nav-item"  @click="changeRevision('original')">
                                <a class="nav-link" v-bind:class="[revisionTab === 'original' ? 'active' : '']" href="#" ><div>Original Version</div></a>
                            </li>
                            <li class="nav-item"  @click="changeRevision('revised')">
                                <a class="nav-link" v-bind:class="[revisionTab === 'revised' ? 'active' : '']" href="#" ><div>Revised Version</div></a>
                            </li>
                        </ul>

                        <el-select
                            v-if="loggedUser.role !== UserRoles.APPLICANT && revisionTab === 'revised'"
                            class="filter-select mr-2 mb-2"
                            style="position: absolute; right: 15.5em; margin-top: -66px; z-index: 10;"
                            v-model="revisionStatus"
                            :placeholder="$t('proposals.select__change_revision_status')"
                            @change="changeRevisionStatus"
                        >
                            <el-option v-for="item in proposalStatuses" :key="item" :label="item" :value="item"/>
                        </el-select>

                        <grant-wizard v-if="CallForm.initialized" :is-editable="CallForm.isFPEditable">
                            <grant-wizard-tab :before-change="() => validateStep('fp-project-presentation')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">1</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{ $t('proposals.fp_step_title__project_presentation') }}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <full-proposal-step-project-presentation ref="fp-project-presentation"></full-proposal-step-project-presentation>
                                </div>
                            </grant-wizard-tab>

                            <grant-wizard-tab :before-change="() => validateStep('fp-applicant')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">2</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{$t('proposals.fp_step_title__applicant')}}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <full-proposal-step-applicant ref="fp-applicant"></full-proposal-step-applicant>
                                </div>
                            </grant-wizard-tab>

                            <grant-wizard-tab :before-change="() => validateStep('fp-full-proposal')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">3</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{$t('proposals.fp_step_title__full_proposal')}}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <full-proposal-step-full-proposal ref="fp-full-proposal"></full-proposal-step-full-proposal>
                                </div>
                            </grant-wizard-tab>

                            <grant-wizard-tab :before-change="() => validateStep('fp-budget')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">4</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{$t('proposals.fp_step_title__budget')}}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <full-proposal-step-budget ref="fp-budget"></full-proposal-step-budget>
                                </div>
                            </grant-wizard-tab>

                            <!-- <grant-wizard-tab :before-change="() => validateStep('fp-logical-framework')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">5</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{$t('proposals.fp_step_title__logical_framework')}}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <full-proposal-step-logical-framework ref="fp-logical-framework"></full-proposal-step-logical-framework>
                                </div>
                            </grant-wizard-tab> -->

                            <grant-wizard-tab :before-change="() => validateStep('fp-supporting-documents')">
                                <template slot="label">
                                    <span clss="call-icon" style="font-size: 20px">5</span>
                                </template>
                                <template slot="tabItemTitle">
                                    <p class="wizard-tab-title">{{$t('proposals.fp_step_title__supporting_documents')}}</p>
                                </template>
                                <div class="tab-outer-content">
                                    <h3 class="reference-nr" v-if="CallForm.reference">Reference: {{ CallForm.reference }}</h3>
                                    <full-proposal-step-supporting-documents ref="fp-supporting-documents"></full-proposal-step-supporting-documents>
                                </div>
                            </grant-wizard-tab>
                        </grant-wizard>
                    </tab-pane>
                </tabs>
            </div>
        </div>
    </div>
</template>
<script>
import ConceptNoteStepProjectPresentation from './ConceptNote/Steps/ProjectPresentation';
import ConceptNoteStepApplicant from './ConceptNote/Steps/Applicant';
import ConceptNoteStepConceptNote from './ConceptNote/Steps/ConceptNote';
import ConceptNoteStepSupportingDocuments from './ConceptNote/Steps/SupportingDocuments';

import FullProposalStepProjectPresentation from './FullProposal/Steps/ProjectPresentation';
import FullProposalStepApplicant from './FullProposal/Steps/Applicant';
import FullProposalStepFullProposal from './FullProposal/Steps/FullProposal';
import FullProposalStepBudget from './FullProposal/Steps/Budget';
import FullProposalStepLogicalFramework from './FullProposal/Steps/LogicalFramework';
import FullProposalStepSupportingDocuments from './FullProposal/Steps/SupportingDocuments';

import { EventBus } from '@/event-bus.js';
import swal from 'sweetalert2';
import { GrantWizard, GrantWizardTab, TabPane, Tabs } from 'src/components';
import {CallForm, ProposalService, UserRoles} from "@/services";
import { Select, Option } from 'element-ui';

export default
{
    data()
    {
        return {
            UserRoles,
            CallForm,
            activeTab: '',
            revisionTab: 'original',
            proposalStatuses:
                [
                    'DRAFT',
                    'SUBMITTED'
                ],
            revisionStatus: "",
        }
    },
    components:
    {
        [Select.name]: Select,
        [Option.name]: Option,
        GrantWizard,
        GrantWizardTab,
        TabPane,
        Tabs,
        ConceptNoteStepProjectPresentation,
        ConceptNoteStepApplicant,
        ConceptNoteStepConceptNote,
        ConceptNoteStepSupportingDocuments,
        FullProposalStepProjectPresentation,
        FullProposalStepApplicant,
        FullProposalStepFullProposal,
        FullProposalStepBudget,
        FullProposalStepLogicalFramework,
        FullProposalStepSupportingDocuments,
    },
    created()
    {
        EventBus.$off('set-active-tab');

        EventBus.$on('wizard-save-progress', data =>
        {
            this.onBeforeSaveProgress(data);
        });

        EventBus.$on('wizard-complete-progress', data =>
        {
            this.onBeforeCompleteProgress(data);
        });
    },
    mounted()
    {
        console.log(CallForm.technical_status);

        if (CallForm.technical_status === 'Preselected')
        {
            // $t('proposals.tab__full_proposal')
            this.activeTab = $t('proposals.tab__full_proposal');
        }

        this.revisionStatus = CallForm.revision_status
    },
    async beforeCreate()
    {
        let vm = this;
        vm.loggedUser = vm.$store.getters['Auth/loggedUser'];

    },
    methods:
    {
        async activateTab(ev)
        {
            CallForm.isFullProposal = ev.id === 'full-proposal';
        },

        async onBeforeSaveProgress(data)
        {
            const valid = await this.validate();

            if (valid)
            {
                EventBus.$emit('grant-save-progress', data);
            }
        },

        async onBeforeCompleteProgress(data)
        {
            const valid = await this.validate();

            if (!valid)
            {
                return;
            }

            var submitConfirmation = await this.showPreSubmitNotification().then((result) =>
            {
                if(result.value){
                    this.revisionStatus = "SUBMITTED"
                }

                return result.value ? true : false;
            });

            if (submitConfirmation)
            {
                EventBus.$emit('grant-complete-progress', data);
            }
        },

        async validate()
        {
            const vm = this;
            let valid = true;
            let mandatoryFields =
            [
                {
                    translation: vm.$t('proposals.field_title__region'),
                    value: CallForm.regionId
                }
            ];
            let errorFields = [];

            mandatoryFields.forEach(item =>
            {
                if (item.value === undefined || !item.value || (Array.isArray(item.value) && !item.value.length))
                {
                    errorFields.push(item.translation);
                }
            });

            if (errorFields.length)
            {
                valid = false;

                await this.showNotificationMandatoryFields(errorFields);

                EventBus.$emit('set-active-tab',
                {
                    masterNickname: 'technical',
                    masterIndex: 0,
                    childIndex: 0,
                    validate: true
                });
            }
            return valid;
        },

        async doExport(stage)
        {
            const vm = this;
            const loader = vm.$loading.show();
            const callId = parseInt(vm.$route.params.callId);
            const proposalId = parseInt(vm.$route.params.proposalId);

            const response = await ProposalService.export({
                stage: stage,
                call_id: callId,
                proposal_id: proposalId
            }).catch((error) => {});

            loader.hide();

            if (response && response.data.success === true)
            {
                const pdf_url = response.data.pdf_url;
                const zip_url = response.data.zip_url || '';

                let html = vm.$t('full_proposal.notification__success_message') + '<br/><br/>' +
                    '<a class="btn btn-primary mr-3" target="_blank" href="' + pdf_url + '">' + vm.$t('full_proposal.notification__download_pdf') + '</a>' +
                    (zip_url !== '' ? '<a class="btn btn-warning" target="_blank" href="' + zip_url + '">' + vm.$t('full_proposal.notification__download_zip') + '</a>' : '');

                await swal({
                    title: vm.$t('general.notification__success'),
                    html: html,
                    type: 'success',
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            }
            else
            {
                let html = vm.$t('full_proposal.notification__error_message');

                await swal({
                    title: vm.$t('general.notification__warning'),
                    html: html,
                    type: 'warning',
                    showConfirmButton: true,
                    showCloseButton: true,
                });
            }
        },

        validateStep(ref)
        {
            const $ref = this.$refs[ref];

            return ($ref.validate) ? $ref.validate() : true;
        },

        showNotificationMandatoryFields(fields) {
            for (var i = 0; i < fields.length; i++) {
                fields[i] = "* " + fields[i];
            }
            let fieldsHtml = '<div class="text-danger">' + fields.join("<br>") + '</div>';
            return swal.fire({
                title: this.$t('general.notification__warning'),
                html: this.$t('general.notification__mandatory_fields', [fieldsHtml]).split("\n").join("<br>"),
                type: 'warning',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-primary btn-fill',
                confirmButtonText: 'OK'
            })
        },

        showPreSubmitNotification() {
            return swal.fire({
                title: this.$t('general.notification__warning'),
                html: this.$t('general.notification__pre_submit_application').split("\n").join("<br>"),
                type: 'warning',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-primary btn-fill',
                confirmButtonText: this.$t('general.notification__submit_application'),
                cancelButtonClass: 'ml-3 btn btn-danger btn-fill',
                cancelButtonText: this.$t('general.notification__cancel_submit_application'),
            })
        },

        async changeRevision(state) {
            const objectAssignDeep = require('object-assign-deep');
            let vm = this;

            vm.revisionTab = state;

            await ProposalService.getProposal(parseInt(vm.$route.params.proposalId),state).then((response) =>
            {
                console.log(response);
                CallForm.organization = response.data.organization;

                CallForm.model = objectAssignDeep(CallForm.model, response.data.data);
                CallForm.files = {
                    ...CallForm.files,
                    ...response.data.files
                };

                CallForm.reference = response.data.reference;
                CallForm.objectives = {
                    ...CallForm.objectives,
                    ...response.data.objectives
                };
                CallForm.organization_type = {
                    ...CallForm.organization_type,
                    ...response.data.organization_type
                };
                CallForm.user = {
                    ...CallForm.user,
                    ...response.data.user
                };
                CallForm.status = response.data.status;
                CallForm.fp_status = response.data.fp_status;
                CallForm.technical_status = response.data.technical_status;
                CallForm.revision_status = response.data.revision_status;

                this.revisionStatus = response.data.revision_status

                if (!CallForm.model.full_proposal.objectives) {
                    CallForm.model.full_proposal.objectives = {
                        sdgs: {_forceObject: true},
                        targets: {_forceObject: true}
                    };
                }

                if (!CallForm.model.full_proposal.objectives.sdgs) {
                    CallForm.model.full_proposal.objectives.sdgs = {_forceObject: true};
                }

                if (!CallForm.model.full_proposal.objectives.targets) {
                    CallForm.model.full_proposal.objectives.targets = {_forceObject: true};
                }

                CallForm.regionId = response.data.region_id;
                CallForm.organization_name = response.data.organization;

                if (vm.revisionTab === 'revised'){
                    CallForm.isRevisedTabActive = true

                    if (CallForm.revision_status === 'DRAFT') {
                        CallForm.isFPEditable = true;
                    } else {
                        CallForm.isFPEditable = false;
                    }
                } else {
                    CallForm.isRevisedTabActive = false
                    CallForm.isFPEditable = vm.loggedUser.role === UserRoles.APPLICANT && response.data.fp_status !== 'SUBMITTED';
                }
                CallForm.initialized = true;

                CallForm.is_revision = false;
                if(vm.revisionTab === 'revised'){
                    CallForm.is_revision = true;
                }

            }).catch((error) =>
            {
                console.log(error);
                // vm.$router.push('/');
            });
        },

        async changeRevisionStatus()
        {
            const vm = this;

            if (confirm(vm.$t('monitoring.confirm__change_revision_status')))
            {
                ProposalService.updateRevisionStatus(vm.$route.params.proposalId,
                    {
                        status: this.revisionStatus
                    }).then(function (response)
                {
                    if(vm.revisionStatus === 'DRAFT'){
                        CallForm.isFPEditable = true;
                        CallForm.initialized = true;
                    }else {
                        CallForm.isFPEditable = false;
                        CallForm.initialized = true;
                    }
                });
            }
        },
    }
};
</script>
<style>
.call-icon
{
    font-size: 20px !important;
}

.tab-outer-content
{
    position: relative;
    padding: 0 20px;
}

.reference-nr
{
    position: absolute;
    top: -10px;
    right: 10px;
    z-index: 10;
}

.dropdown-menu a
{
    display: block;
    width: 100%;
    padding: 10px 15px;
    cursor: pointer;
}
</style>
